module.exports = __webpack_public_path__ + "732b8e23f8a3df2b7e299f715c814375.mp4";